import { Header } from "@/components/Header";
import HeroSection from "@/components/landing/HeroSection";
import HowItWorks from "@/components/landing/HowItWorks";
import FeaturesGrid from "@/components/landing/FeaturesGrid";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import { useSEO } from "@/hooks/useSEO";

const Landing = () => {
  useSEO({
    title: "Resume Flow AI - Free ATS-Optimized Resume Builder | Apply Faster, Land More",
    description: "Build ATS-optimized resumes in under 2 minutes. Paste your content, structure instantly, toggle sections, export PDF/DOCX, and track job applications — all free.",
    canonical: "/",
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <HeroSection />
      <HowItWorks />
      <FeaturesGrid />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Landing;
